/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PageContent,
} from '../models';
import {
    PageContentFromJSON,
    PageContentToJSON,
} from '../models';

/**
 * 
 */
export class PageContentApi extends runtime.BaseAPI {

    /**
     * Gets a list of page content
     * List Page Content
     */
    async listPageContentRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PageContent>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-ms-client-principal"] = this.configuration.apiKey("x-ms-client-principal"); // api-security authentication
        }

        const response = await this.request({
            path: `/page-content`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PageContentFromJSON));
    }

    /**
     * Gets a list of page content
     * List Page Content
     */
    async listPageContent(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PageContent>> {
        const response = await this.listPageContentRaw(initOverrides);
        return await response.value();
    }

}
